// ✅ FILE: src/components/Cookies/FacebookPixelWrapper.jsx

import { useEffect, useState } from 'react';

const COOKIE_NAME = 'cookieConsent';
const FB_COOKIES = ['_fbp', 'fr'];

export default function FacebookPixelWrapper({ pixelId }) {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    console.log('[FB] Checking initial consent state');
    const match = document.cookie.match(/cookieConsent=([^;]+)/);
    if (match) {
      try {
        const parsed = JSON.parse(decodeURIComponent(match[1]));
        console.log('[FB] Initial consent parsed:', parsed);
        setConsent(parsed);
      } catch (err) {
        console.warn('[FB] Failed to parse initial cookieConsent:', err);
      }
    } else {
      console.log('[FB] No initial cookieConsent found');
    }
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel('cookie-consent');
    channel.onmessage = (event) => {
      console.log('[FB] Broadcast received:', event.data);
      if (event.data?.type === 'consent-updated') {
        try {
          const match = document.cookie.match(/cookieConsent=([^;]+)/);
          if (match) {
            const parsed = JSON.parse(decodeURIComponent(match[1]));
            console.log('[FB] Updated consent parsed after broadcast:', parsed);
            setConsent(parsed);

            if (!parsed.marketing) {
              console.log('[FB] Marketing consent revoked via broadcast — removing Meta Pixel');
              cleanupFBPixel();
            }
          } else {
            console.log('[FB] No cookieConsent found after broadcast');
          }
        } catch (err) {
          console.warn('[FB] Failed to parse cookieConsent after broadcast:', err);
        }
      }
    };
    return () => channel.close();
  }, []);

  useEffect(() => {
    console.log('[FB] Consent or PixelID updated:', { consent, pixelId });

    if (consent?.marketing && pixelId) {
      console.log('[FB] Consent granted & Pixel ID present — injecting Meta Pixel', pixelId);

      if (!window.fbq) {
        console.log('[FB] fbq not found, injecting script');
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = true;
          t.src = `https://connect.facebook.net/en_US/fbevents.js`;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script');

        fbq('init', pixelId);
        fbq('track', 'PageView');
        console.log('[FB] Pixel initialized with ID:', pixelId);
      } else {
        console.log('[FB] fbq already exists — skipping script injection');
      }
    } else {
      if (!consent?.marketing) console.log('[FB] Marketing consent not granted');
      if (!pixelId) console.warn('[FB] No Pixel ID provided');
    }
  }, [consent, pixelId]);

  return null;
}

function cleanupFBPixel() {
  console.log('[FB] Cleaning up Meta Pixel');
  FB_COOKIES.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
    console.log(`[FB] Cookie removed: ${name}`);
  });

  window.fbq = function () {
    console.warn('[FB] Blocked tracking call:', arguments);
  };

  const fbScript = document.querySelector('script[src*="fbevents.js"]');
  if (fbScript) {
    fbScript.remove();
    console.log('[FB] Removed script fbevents.js');
  } else {
    console.log('[FB] No fbevents.js script found to remove');
  }
}
